module.exports = __webpack_public_path__ + "static/frangipane-con-frutos-rojos-1-baaa049acb108d57d2fd65b891f61588.jpg";